<script lang="ts">
	import { page } from '$app/state';
	import type { ISbStoryData } from '@storyblok/js';
	import Blok from '../blok.svelte';

	interface Props {
		content: ISbStoryData<{
			allow_list: Array<ISbStoryData>;
			block_list: Array<ISbStoryData>;
			content: ISbStoryData[];
		}>['content'];
	}

	let { content }: Props = $props();

	function hasReference(pages: Array<ISbStoryData>, pathname: string) {
		return pages
			.map(({ full_slug }) => (full_slug === 'home' ? '/' : `/${full_slug}`))
			.includes(pathname);
	}

	let isAllowed = $derived(
		content.allow_list.length === 0 || hasReference(content.allow_list, page.url.pathname)
	);
	let isBlocked = $derived(
		content.block_list.length > 0 && hasReference(content.block_list, page.url.pathname)
	);
</script>

{#if isAllowed && !isBlocked}
	{#each content.content as block}
		<Blok content={block} />
	{/each}
{/if}
